import * as React from "react";
import type { SVGProps } from "react";
const SvgCalendarChartAnalyticsBarChart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={24}
    fill="none"
    viewBox="0 0 25 24" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7.25 11h4M7.75 3v3M16.75 3v3M9.25 21h-3a3 3 0 0 1-3-3V7.5a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3V11"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12.75 17h2a.5.5 0 0 1 .5.5V21h-3v-3.5a.5.5 0 0 1 .5-.5M15.75 13h2a.5.5 0 0 1 .5.5V21h-3v-7.5a.5.5 0 0 1 .5-.5M18.75 15h2a.5.5 0 0 1 .5.5V21h-3v-5.5a.5.5 0 0 1 .5-.5"
      clipRule="evenodd"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7.25 15h1"
    />
  </svg>
);
export default SvgCalendarChartAnalyticsBarChart;
